<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <v-btn
          v-if="$auth.policies['add-new-teaching']"
          class="mr-2"
          depressed
          color="primary"
          @click="addCore = !addCore"
          :block="$vuetify.breakpoint.smAndDown"
        >
          <v-icon left>add</v-icon>
          Phân công chính khóa
        </v-btn>
        <v-btn
          v-if="$auth.policies['add-new-teaching']"
          outlined
          color="primary"
          @click="addExtra = !addExtra"
          :block="$vuetify.breakpoint.smAndDown"
          :class="{ 'mt-6': $vuetify.breakpoint.mdAndDown }"
        >
          <v-icon left>add</v-icon>
          Phân công bổ trợ
        </v-btn>
      </v-col>
      <v-col cols="12" md="6">
        <div class="d-flex justify-end">
          <v-btn
            v-if="$auth.policies['add-new-ownClass']"
            depressed
            color="primary"
            @click="addState = !addState"
            :block="$vuetify.breakpoint.smAndDown"
          >
            <v-icon left>add</v-icon>
            Phân công chủ nhiệm
          </v-btn>
        </div>
      </v-col>

      <!-- giang day -->
      <v-col cols="12" md="6" v-if="$auth.policies['view-teaching-list']">
        <v-card outlined>
          <v-card-title>
            Công tác giảng dạy
          </v-card-title>
          <v-divider />
          <v-card-text>
            <h1 class="text-center py-3" style="color: #46BE8A">{{ teachingClassCount }}</h1>
            <div class="text-center pb-3">Số lớp đang dạy</div>
          </v-card-text>
          <v-data-table
            v-if="teachings.length"
            mobile-breakpoint="0"
            item-key="id"
            hide-default-footer
            :headers="teachingHeaders"
            :items="teachings"
            :loading="teachingLoading"
            :items-per-page="-1"
          >
            <template v-slot:[`item.class.title`]="{ item }">
              <router-link
                v-if="$auth.policies['view-class']"
                style="text-decoration: none"
                :to="'/class/' + (item.class && item.class.id)"
              >
                <span v-if="item.class">{{ item.class && item.class.title }}</span>
              </router-link>
              <div v-else>
                <span v-if="item.class">{{ item.class && item.class.title }}</span>
              </div>
            </template>
            <template v-slot:[`item.updatedAt`]="{ item }">
              {{ item.updatedAt | ddmmyyyy }}
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <TeachingListAction :selectedTeaching="item" @updateDone="updateTeachingDone" />
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" v-else> </v-col>

      <!-- chu nhiem -->
      <v-col cols="12" md="6" v-if="$auth.policies['view-ownClass-list']">
        <v-card outlined>
          <v-card-title>
            Công tác chủ nhiệm
          </v-card-title>
          <v-divider />
          <v-card-text>
            <h1 class="text-center py-3" style="color: #46BE8A">
              {{ teacher.ownClasses ? teacher.ownClasses.length : 0 }}
            </h1>
            <div class="text-center pb-3">Số lớp đang chủ nhiệm</div>
          </v-card-text>
          <v-data-table
            v-if="teacher.ownClasses && teacher.ownClasses.length"
            mobile-breakpoint="0"
            item-key="id"
            hide-default-footer
            :headers="ownClassHeaders"
            :items="ownClasses"
            :loading="ownClassTeacherLoading"
            :items-per-page="-1"
          >
            <template v-slot:[`item.title`]="{ item }">
              <router-link
                v-if="$auth.policies['view-class']"
                style="text-decoration: none"
                :to="'/class/' + (item && item.id)"
              >
                <span v-if="item">{{ item && item.title }}</span>
              </router-link>
              <div v-else>
                <span v-if="item">{{ item && item.title }}</span>
              </div>
            </template>
            <template v-slot:[`item.studentNum`]="{ item }">
              {{ item.students && item.students.length }}
            </template>
            <template v-slot:[`item.fromDate`]="{ item }">
              {{ item.metadata && item.metadata[`${teacher.id}-${currentSchoolYear.id}`] | ddmmyyyy }}
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <OwnClassListAction :teacher="teacher" :ownClass="item" @updateDone="ownClassTeacherRefresh" />
            </template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="12" md="12">
        <v-card outlined>
          <v-card-title>
            Sổ sách giảng dạy
          </v-card-title>
          <v-divider />

          <v-data-table
            mobile-breakpoint="0"
            item-key="id"
            hide-default-footer
            :headers="documentHeaders"
            :items="documents"
            :loading="documentLoading"
            :items-per-page="-1"
          >
            <template v-slot:[`item.type`]="{ item }">
              {{ item.documentType.title }}
            </template>
            <template v-slot:[`item.title`]="{ item }">
              <div @click="item.file ? openLink(item.file) : null" style="color: #1a0dab;; cursor: pointer">
                {{ item.file && item.file.name }}
              </div>
            </template>
            <template v-slot:[`item.createdAt`]="{ item }">
              {{ item.createdAt | ddmmyyyy }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <TeachingNewDialog :defaultTeacher="teacher" :state="addCore" @done="teachingRefresh" />
    <ExtraTeachingNewDialog :state="addExtra" :defaultTeacher="teacher" @done="teachingRefresh" />
    <OwnClassTeacherNewDialog :state="addState" :defaultTeacher="teacher" @done="headTeacherAdded" />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import TeachingListAction from '@/modules/teacher/TeachingListAction.vue'
import OwnClassListAction from '@/modules/teacher/OwnClassListAction.vue'
import ExtraTeachingNewDialog from '@/modules/teacher/ExtraTeachingNewDialog.vue'
import TeachingNewDialog from '@/modules/teacher/TeachingNewDialog'
import OwnClassTeacherNewDialog from '@/modules/teacher/OwnClassTeacherNewDialog'

export default {
  components: {
    TeachingListAction,
    OwnClassListAction,
    ExtraTeachingNewDialog,
    TeachingNewDialog,
    OwnClassTeacherNewDialog
  },
  data() {
    return {
      addCore: false,
      addExtra: false,
      addState: false,
      ownClassTeacherLoading: false,
      teachingLoading: false,
      documentLoading: false,
      selectedTeaching: null,
      deleteState: false,
      editState: false,
      selectedOwnClass: null,
      editOwnClassState: false,
      teachingHeaders: [
        {
          text: 'Khối',
          value: 'grade.gradeNumber',
          align: 'left',
          sortable: false,
          show: true,
          width: 50
        },
        {
          text: 'Lớp',
          value: 'class.title',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Bộ môn',
          value: 'subjectGroup.title',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Từ ngày',
          align: 'left',
          value: 'updatedAt',
          sortable: false,
          show: true
        },
        {
          text: 'Thao tác',
          align: 'left',
          value: 'action',
          sortable: false,
          show: true
        }
      ],
      ownClassHeaders: [
        {
          text: 'Khối',
          value: 'grade.gradeNumber',
          align: 'left',
          sortable: false,
          show: true,
          width: 50
        },
        {
          text: 'Lớp',
          value: 'title',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Số học sinh',
          value: 'studentNum',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Từ ngày',
          value: 'fromDate',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Thao tác',
          value: 'action',
          align: 'left',
          sortable: false,
          show: true
        }
      ],
      documentHeaders: []
    }
  },
  props: {},
  computed: {
    ...mapState('teacher', ['teacher', 'teachings', 'ownClasses', 'teachingClassCount', 'documents']),
    ...mapGetters('app', ['currentSchoolYear']),
    ...mapGetters('auth', ['profile', 'role'])
  },
  methods: {
    ...mapActions('teacher', [
      'fetchTeachings',
      'updateTeaching',
      'removeTeaching',
      'fetchOwnClasses',
      'updateTeachingList',
      'updateOwnClassList',
      'fetchTeacherDocuments'
    ]),
    ...mapActions('ownClassTeacher', ['updateMessageGroup']),

    updateTeachingDone(teaching) {
      this.updateTeachingList(teaching)
    },
    updateOwnClasDone(classData) {
      this.updateOwnClassList(classData)
    },
    async teachingRefresh() {
      this.teachingLoading = true
      await this.fetchTeachings({ teacher: this.teacher.id })
      this.teachingLoading = false
    },
    async ownClassTeacherRefresh() {
      this.ownClassTeacherLoading = true
      await this.fetchOwnClasses({ teacher: this.teacher.id })
      this.ownClassTeacherLoading = false
    },
    async documentRefresh() {
      this.documentLoading = true
      await this.fetchTeacherDocuments({ createdTeacher: this.teacher.id })
      this.documentLoading = false
    },
    async headTeacherAdded(classData) {
      // update header teacher => update message group
      await this.updateMessageGroup({
        classData
      })
      await this.ownClassTeacherRefresh()
    },
    openLink(file) {
      if (file && file.url) window.open(file.url, '_blank')
    }
  },

  async created() {
    if (this.role.type === 'inspector') {
      this.documentHeaders = [
        {
          text: 'Thư mục',
          value: 'type',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tên tài liệu',
          value: 'title',
          align: 'left',
          sortable: false
        }
      ]
    } else {
      this.documentHeaders = [
        {
          text: 'Thư mục',
          value: 'type',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tên tài liệu',
          value: 'title',
          align: 'left',
          sortable: false
        },
        {
          text: 'Ngày tạo',
          value: 'createdAt',
          align: 'left',
          sortable: false
        }
      ]
    }

    await Promise.all([this.teachingRefresh(), this.ownClassTeacherRefresh(), this.documentRefresh()])
    // await this.teachingRefresh()
    // await this.ownClassTeacherRefresh()
  }
}
</script>
